import { useTranslation } from 'react-i18next'
import { brandInfo } from '@/mocks/site'

export default function FloatingWhatsApp() {
  const { t } = useTranslation()

  return (
    <a
      href={brandInfo.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Book a shoot on WhatsApp"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 h-14 px-4 rounded-full bg-primary-500 text-background-50 cursor-pointer shadow-lg hover:bg-primary-600 transition-colors group"
    >
      <span className="relative w-8 h-8 flex items-center justify-center shrink-0">
        <span className="absolute inset-0 rounded-full bg-background-50/25 animate-ping" />
        <i className="ri-whatsapp-line text-2xl relative" />
      </span>
      <span className="hidden sm:block text-sm font-medium whitespace-nowrap pr-1">{t('common.bookOnWhatsapp')}</span>
    </a>
  )
}